// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__spinner__KSDbo","spin":"spinner__spin__F1IR9"};